// ReactJs
import React from 'react'
import { useHistory } from 'react-router'
// Node modules
import styled from 'styled-components'
// Styles
import theme from '../../../common/theme'
import Button from '../../../common/Button'

const WelcomePageLogoutContainer = styled.div`
  margin-top: 36px;
  margin-left: 20px;
  margin-bottom: 100px;

  .logout-btn {
    background: ${ theme.palette.white };
    color: ${ theme.palette.blue };
    border: 1px solid ${ theme.palette.blue };
  }

`

export default function WelcomePageLogout({ ...props }) {
  const history = useHistory()

  const logout = () => {
    history.push('/logout')
  }

  return (
    <WelcomePageLogoutContainer>
      <Button className="logout-btn" onClick={ logout } >
        Se déconnecter
      </Button>
    </WelcomePageLogoutContainer>
  )
}
